@if (isReady === true) {
  <div class="animal-container" #compositionContainer>
    @if (currentData) {
      <app-animal-canvas #canvas [creature]="currentData"></app-animal-canvas>
    }
    @if (currentData) {
      <app-animal-controls (next)="onNext()" (previous)="onPrevious()"
        (saveUserImage)="onSaveUserImage($event)" (update)="redraw($event)" [creature]="currentData" [width]="controlsWidth"
        [navigationAllowed]="availableData.length > 1" [controlsAllowed]="displayControls">
      </app-animal-controls>
    }
    @if (!currentData) {
      <div class="message">{{'gamification.avatar.unavailable' | translate}}</div>
    }
  </div>
}

@if (isReady === false) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
}